exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na:link .priority-high {\n    color: #f44336!important;\n}\na:link .priority-medium {\n    color: orange !important;\n}\n", ""]);

// exports
